import { __read } from "tslib";
import React, { useState } from 'react';
import { AppBarErrorBoundary } from './AppBarErrorBoundary';
/**
 * Context menu for launch tiles to support pinning and other commands
 * @param onPinStateChange Event fired when pin state for a tile changes
 * @param isPinned True if the connected tile is pinned. False otherwise.
 * @returns JSX.Element
 */
export var LazyTileContextMenuRender = function (_a, ref) {
    var tileContextMenuRef = _a.tileContextMenu, style = _a.style, _b = _a.customImportHandler, customImportHandler = _b === void 0 ? function (p) { return p; } : _b, children = _a.children;
    // This is the state used to determine whether the context menu is open or not.
    // Note that it has three states:
    // True for open
    // False for closed
    // null indicates that the context menu is closed and has never been opened, which
    // means we don't have to lazy load the actual implementation yet.
    var _c = __read(useState(null), 2), contextMenuOpen = _c[0], setContextMenuOpen = _c[1];
    var _d = __read(useState(null), 2), menuItemCallbacks = _d[0], setMenuItemCallbacks = _d[1];
    var _e = __read(useState(undefined), 2), menuTarget = _e[0], setMenuTarget = _e[1];
    var _f = __read(useState(''), 2), targetAppId = _f[0], setTargetAppId = _f[1];
    React.useImperativeHandle(ref, function () { return ({
        open: function (target, index, menuCallbacks, targetAppTileId) {
            menuCallbacks.pinnedIndex = index;
            setTargetAppId(targetAppTileId);
            setMenuTarget(target);
            setMenuItemCallbacks(menuCallbacks);
            setContextMenuOpen(true);
        },
    }); }, []);
    // Lazy renderer for the context menu
    var TileContextMenu = React.lazy(function () {
        return customImportHandler(import(
        /* webpackChunkName: "appbar-control-tilecontextmenu" */ './TileContextMenu'));
    });
    return (React.createElement(React.Fragment, null,
        children,
        contextMenuOpen != null && menuItemCallbacks != null ? (React.createElement(AppBarErrorBoundary, { boundarySource: "LazyTileContextMenu" },
            React.createElement(React.Suspense, { fallback: "" },
                React.createElement(TileContextMenu, { tileContextMenu: tileContextMenuRef, targetAppTileId: targetAppId, style: style, contextMenuOpen: contextMenuOpen, setContextMenuOpen: setContextMenuOpen, menuTarget: menuTarget, menuItemCallbacks: menuItemCallbacks })))) : null));
};
export var LazyTileContextMenu = React.forwardRef(LazyTileContextMenuRender);
//# sourceMappingURL=LazyTileContextMenu.js.map